import { SyntheticEvent } from 'react';
import { ContextMenuRow } from '../../../../reducers/gerenciadorPrecos/contextMenu';

/**
 * Marca as sub-linhas da linha expandida (Atacado, Oferta). O clique direito sobe até a linha do
 * rsuite (onRowContextMenu), que lê a marca mais próxima do alvo para saber qual linha abriu o menu.
 */
export const CONTEXT_MENU_ROW_ATTRIBUTE = 'data-context-menu-row';

const SUB_ROWS: ReadonlyArray<ContextMenuRow> = ['WHOLESALE', 'OFFER'];

const isSubRow = (value: string | null | undefined): value is ContextMenuRow => SUB_ROWS.includes(value as ContextMenuRow);

export const getContextMenuRow = (event?: SyntheticEvent): ContextMenuRow => {
  const target = event?.target;
  if (!(target instanceof Element)) return 'REGULAR';

  const subRow = target.closest(`[${CONTEXT_MENU_ROW_ATTRIBUTE}]`)?.getAttribute(CONTEXT_MENU_ROW_ATTRIBUTE);
  return isSubRow(subRow) ? subRow : 'REGULAR';
};

/** Atributo que identifica a sub-linha para o menu de contexto; espalhar no `<tr>` da sub-linha. */
export const getContextMenuRowProps = (row: ContextMenuRow) => ({ [CONTEXT_MENU_ROW_ATTRIBUTE]: row });
